"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./AccessoriesCart.scss");
var CartViewPanelProps_1 = require("../../panels/CartViewPanel/CartViewPanelProps");
var CartViewPanel_1 = require("../../panels/CartViewPanel");
var utils_1 = require("@idp/ui-components/utils");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var Utils = require("../../../utils/UtilityFunctions");
var CartUtils = require("../../../utils/CartUtilFunctions");
var CommonUtils = require("../../../utils/CommonUtilFuntions");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var Api_1 = require("../../../api/Api");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var RemoveModalContent_1 = require("../shared/RemoveModalContent");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var components_1 = require("@idp/duc/components");
var CommonHelper = require("../../../api/CommonHelper");
var CartCommonStyle = require("../../../styles/CartCommon.scss");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var LineItem_1 = require("../../CommonCart/common/LineItem");
var CartItemPromo_1 = require("../../atoms/CartItemPromo");
var PostpaidAccessoryModal_1 = require("../WirelessCart/PostpaidAccessoryModal/PostpaidAccessoryModal");
var CartZipEdit_1 = require("../../CartLob/shared/CartZipEdit/CartZipEdit");
var TextTooltip_1 = require("../shared/TextTooltip");
var wirelessRTI = require("./../WirelessCart/WirelessRTI");
var textTooptipStyles = require("../shared/TextTooltip/TextTooltip.scss");
var SavingsAndPromos_1 = require("../../panels/SavingsAndPromos/SavingsAndPromos");
var PromoPanel_1 = require("../../panels/PromoPanel");
var AccessoriesCart = /** @class */ (function (_super) {
    __extends(AccessoriesCart, _super);
    function AccessoriesCart(props) {
        var _this = _super.call(this, props) || this;
        _this.isCommonCart = false;
        _this.itemImage = [];
        _this.itemDetails = [];
        _this.itemOtherInfo = [];
        _this.editUrl = '';
        _this.isWirelessAccCart = false;
        _this.totalLosgItems = 0;
        _this.totalOneTimeSavings = 0;
        _this.state = {
            isRemoveModalOpen: false,
            showAccessoriesCart: true,
        };
        _this.initializeEvents();
        _this.buildCartViewPanelData = _this.buildCartViewPanelData.bind(_this);
        _this.initializeProps = _this.initializeProps.bind(_this);
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.onCartRemove = _this.onCartRemove.bind(_this);
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.showLineItems = _this.showLineItems.bind(_this);
        _this.getLineItemPrice = _this.getLineItemPrice.bind(_this);
        _this.getLineItemContent = _this.getLineItemContent.bind(_this);
        _this.buildItemInfo = _this.buildItemInfo.bind(_this);
        _this.editLineItem = _this.editLineItem.bind(_this);
        _this.removeLineItem = _this.removeLineItem.bind(_this);
        _this.changeAccessoryQuantity = _this.changeAccessoryQuantity.bind(_this);
        _this.showQuantity = _this.showQuantity.bind(_this);
        _this.showEditZipCode = _this.showEditZipCode.bind(_this);
        _this.getEditUrl = _this.getEditUrl.bind(_this);
        _this.savingText = _this.savingText.bind(_this);
        return _this;
    }
    AccessoriesCart.prototype.initializeProps = function () {
        this.payload = CartUtils.getAccessoryCart();
        if (this.payload && this.payload.accessoryCart && this.payload.accessoryCart.losgs) {
            this.losgData = Object.values(this.payload.accessoryCart.losgs);
            this.props.data.dueToday = this.payload.accessoryCart.totalLobDueToday;
            this.props.data.lobTax = this.payload.accessoryCart.totalLobTax;
            this.props.data.promotions = this.payload.accessoryCart.promotions;
            this.props.data.totalLob1stBill = this.payload.accessoryCart.totalLob1stBill;
            this.props.data.shippingFee = this.payload.orderPriceInfo.shippingPrice;
            this.props.data.isTaxCalculated = this.payload.orderPriceInfo.taxCalculated;
            this.isCommonCart = !!(this.props.options && this.props.options.isCommonCart);
            this.isWirelessAccCart = !!(this.props.options && this.props.options.isWirelessAccCart);
            if (this.isCommonCart) {
                this.editUrl = '/buy/accessory/';
            }
            else if (this.isWirelessAccCart) {
                this.editUrl = this.payload.metadata && this.payload.metadata.metadata &&
                    this.payload.metadata.metadata.wirelessMetadata &&
                    this.payload.metadata.metadata.wirelessMetadata.editUrl || '';
            }
            else {
                this.editUrl = this.payload.metadata.metadata && this.payload.metadata.metadata.dtvsMetadata &&
                    this.payload.metadata.metadata.dtvsMetadata.editUrl || '';
            }
        }
    };
    AccessoriesCart.prototype.initializeEvents = function () {
        var _this = this;
        this.cartViewEvents = {
            onEdit: function () {
                if (_this.isCommonCart || _this.isWirelessAccCart) {
                    _this.props.events.onEdit('ACCESSORY', _this.editUrl);
                }
                else {
                    _this.props.events.onEdit('DTVS', _this.editUrl);
                }
            },
            onRemove: this.toggleRemoveModal.bind(this),
        };
    };
    AccessoriesCart.prototype.buildCartViewPanelData = function (data) {
        var _a, _b, _c;
        var dueTodayLegalContents = this.isWirelessAccCart ?
            CartUtils.getLegalIDPDetails(this.cmsContent.dueTodayAccLegalIDP) :
            CartUtils.getLegalIDPDetails(this.cmsContent.dueTodayLegalIDP);
        return {
            due1stBillHeading: this.cmsContent.dueOneTimeCharges,
            due1stBillModalLegalUrl: this.cmsContent.dueOnFirstBillLegal,
            due1stBillPrice: data.totalLob1stBill,
            dueTodayModalLegalContents: dueTodayLegalContents,
            dueTodayModalLegalUrl: (_b = (_a = this.cmsContent) === null || _a === void 0 ? void 0 : _a.dueTodayLegalIDP) === null || _b === void 0 ? void 0 : _b.legalModalPath[0],
            dueTodayPrice: data.dueToday,
            editCTALabel: this.cmsContent.editCTALabel,
            estimatedSalesTax: this.cmsContent.estimatedSalesTax,
            lineOfBusinessName: this.cmsContent.lineOfBusinessName,
            quantity: this.cmsContent.quantity,
            removeItemsLinkLabel: (_c = this.cmsContent) === null || _c === void 0 ? void 0 : _c.removeItemsLinkLabel,
            taxTooltipDown: this.cmsContent.taxTooltipDown,
            taxTooltipUp: this.cmsContent.taxTooltipUp,
        };
    };
    AccessoriesCart.prototype.componentWillMount = function () {
        this.initializeProps();
    };
    AccessoriesCart.prototype.componentDidMount = function () {
        var anchors = document.querySelectorAll('[data-test-id=ACCESSORY_CartViewPanel_LineItem] a');
        anchors.forEach(function (element) {
            if (element.innerHTML.toLowerCase().replace(' ', '') === 'seedetails') {
                element.setAttribute('data-linkDestinationUrl', '/buy/cart/');
            }
        });
    };
    AccessoriesCart.prototype.render = function () {
        var _this = this;
        this.initializeProps();
        this.cmsContent = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.accessorycart.cartSummary;
        this.totalOneTimeSavings = this.payload && this.payload.wirelessCart && this.payload.wirelessCart.savingsInfo &&
            this.payload.wirelessCart.savingsInfo.totalOneTimeSavings || 0;
        if (this.losgData && this.losgData.length > 0 && this.cmsContent) {
            return (React.createElement("div", null,
                React.createElement(CartViewPanel_1.default, { testId: utils_1.default('Accessories', 'CartViewPanel', 'LineItem'), data: this.buildCartViewPanelData(this.props.data), events: this.cartViewEvents, options: {
                        commonPromotionText: '',
                        hideEditAndRemove: this.isCommonCart || this.isWirelessAccCart,
                        isPromoTextApplicable: false,
                        isRemoveAllButtonApplicable: true,
                        planType: CartViewPanelProps_1.PlanType.ACCESSORIES,
                        showAccordions: this.props.options && !!this.props.options.showBundlesTreatment,
                    } },
                    this.showLineItems(),
                    this.getShippingData(),
                    this.getSalesTax()),
                React.createElement(ui_components_1.Modal, { testId: utils_1.default('ACCESSORY', 'Modal', 'ConfirmRemove'), options: {
                        center: true,
                        className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                        show: this.state.isRemoveModalOpen,
                        showClose: true,
                        size: ModalProps_1.ModalSizes.MEDIUM,
                    }, events: {
                        onClose: function () {
                            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                            _this.toggleRemoveModal();
                        },
                    } }, React.createElement(RemoveModalContent_1.default, { testId: utils_1.default('ACCESSORY', 'RemoveModalContent', 'ConfirmRemove'), events: {
                        onCancelClick: function () {
                            _this.toggleRemoveModal();
                        },
                        onRemoveClick: function () {
                            _this.toggleRemoveModal(true);
                        },
                    }, data: {
                        currentLOB: 'ACCESSORY',
                        isBundleinCart: Utils.isBundleinCart().isBundleWithoutAccessory,
                        isSonosinCart: Utils.IsSONOSAccessoryInCart(),
                    } })),
                this.savingText() && React.createElement("div", { className: styles.savingsPromoContainer },
                    React.createElement(SavingsAndPromos_1.default, { data: {
                            disableIcon: true,
                            losgData: this.losgData,
                            oneTimeInfo: {
                                oneTimeSavingsContent: React.createElement(React.Fragment, null),
                                totalOneTimeSavings: this.totalOneTimeSavings,
                            },
                            panelContent: {
                                panelLabel: this.savingsAndPromosCms.panelLabel,
                                savingLabel: this.savingText(),
                            },
                            payLoad: this.payload,
                            showPanel: true,
                        }, options: { expandedView: false } })),
                React.createElement(PromoPanel_1.default, { data: {
                        cartPage: true,
                        displayCloserCoupon: this.props.promoPanelOptions.displayCloserCoupon,
                        losgData: this.losgData,
                    }, events: {
                        doLoading: this.props.promoPanelEvents.doLoading,
                        priceBarUpdates: this.props.promoPanelEvents.priceBarUpdates,
                        showSaveCartModal: this.props.promoPanelEvents.showSaveCartModal,
                    }, options: {
                        autoExpandPromoSection: this.props.promoPanelOptions.autoExpandPromoSection,
                        isNewSavingsPromoComponent: true,
                    } })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    AccessoriesCart.prototype.showLineItems = function () {
        var _this = this;
        this.totalLosgItems = 0;
        if (this.losgData && this.losgData.length > 0) {
            return (React.createElement(React.Fragment, null, this.losgData.map(function (losg, losgIndex) {
                var losgItems = Object.values(losg.lineItems);
                var keyId = "accLosgInfo" + losg.id;
                if (losgItems.length > 0) {
                    _this.totalLosgItems = (_this.losgData.length === 1) ? losgItems.length : 0;
                    return losgItems.map(function (lineItem, index) {
                        keyId = "accItemInfo" + lineItem.id + "}";
                        _this.itemImage = [];
                        _this.itemDetails = [];
                        _this.itemOtherInfo = [];
                        _this.getLineItemContent(lineItem, losg);
                        if (_this.isCommonCart || _this.isWirelessAccCart) {
                            return (React.createElement("div", { key: keyId },
                                index > 0 &&
                                    React.createElement("div", { className: styles.grayLine },
                                        React.createElement("div", { className: CartCommonStyle.grayDivider })),
                                React.createElement("div", null,
                                    wirelessRTI.displayRtiOosAccessoryMessage(lineItem, losg, _this.editLineItem, _this.changeAccessoryQuantity, '/buy/accessory/', true),
                                    " "),
                                React.createElement("div", { className: CartCommonStyle.displayFlex },
                                    React.createElement("div", { className: CartCommonStyle.contentLeft }, _this.itemImage),
                                    React.createElement("div", { className: CartCommonStyle.contentRight },
                                        _this.itemDetails,
                                        React.createElement("div", { className: CartCommonStyle.contentOtherView }, _this.itemOtherInfo))),
                                React.createElement("div", { className: CartCommonStyle.contentMobileView }, _this.itemOtherInfo)));
                        }
                        else {
                            return (React.createElement("div", { key: keyId }, _this.itemDetails));
                        }
                    });
                }
                else {
                    return (React.createElement(React.Fragment, null, " "));
                }
            })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    AccessoriesCart.prototype.getLineItemName = function (lineItem) {
        if (lineItem.itemType && lineItem.displayName) {
            return lineItem.displayName;
        }
        else {
            return '';
        }
    };
    AccessoriesCart.prototype.getPrice = function (price) {
        var finalPrice = 0;
        if (price && price.baseAmount && price.amount) {
            if (price.baseAmount && price.baseAmount.toString() !== '0.00') {
                finalPrice = price.baseAmount;
            }
            else {
                finalPrice = price.amount;
            }
        }
        return finalPrice;
    };
    AccessoriesCart.prototype.getLineItemQuantity = function (lineItem) {
        if (lineItem.itemType && lineItem.displayName && lineItem.quantity) {
            return lineItem.quantity;
        }
        else {
            return 0;
        }
    };
    AccessoriesCart.prototype.shouldDisplayQuantity = function (lineItem) {
        if (lineItem.itemType && lineItem.displayName && lineItem.quantity && lineItem.quantity > 1) {
            return true;
        }
        else {
            return false;
        }
    };
    AccessoriesCart.prototype.getPromotion = function (lineItem) {
        var _this = this;
        var _a;
        if (lineItem && lineItem.promotionReferences && lineItem.promotionReferences.length > 0) {
            var cartPromos = lineItem.promotionReferences.map(function (promoRef, promoIndex) {
                return _this.payload.accessoryCart.promotions.find(function (promo) { return promo.id === promoRef; });
            });
            if (this.payload.enableSplitAccessoryLine && this.isWirelessAccCart &&
                ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'accessory' && lineItem.quantity > 1) {
                cartPromos = CommonUtils.getUpdatedMultipleAccessoryPromos(cartPromos);
            }
            var promotions = cartPromos.map(function (promotion, promoIndex) {
                var _a;
                var showPriceAmt = true;
                var keyId = "promo" + lineItem.id + "_" + promoIndex;
                if (promotion) {
                    if (_this.isCommonCart || _this.isWirelessAccCart) {
                        var promoPriceData = {
                            billingNote: promotion.promotionCycle && promotion.promotionCycle.toString(),
                            price: promotion.totalAmount || promotion.amount,
                        };
                        return (React.createElement("div", { key: keyId, className: styles.promoContainer },
                            React.createElement(CartItemPromo_1.default, { data: {
                                    isExpressUpgradeView: _this.isCommonCart || _this.isWirelessAccCart,
                                    isPriceNegative: true,
                                    isSignaturePromo: _this.payload.enableSignatureEnhancedExperience &&
                                        promotion && (promotion.promotionCategory === 'iruPlanDiscount'
                                        || ((_a = promotion.discountCategory) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'noncontractual'),
                                    promoPrice: promoPriceData.price,
                                    promoText: promotion.promotionName,
                                    promotionCycle: promoPriceData.billingNote,
                                    showPrice: Number(promoPriceData.price) && showPriceAmt,
                                }, options: { testId: utils_1.default('WRLS', "LineItem" + promoIndex) } })));
                    }
                    else {
                        var amount = parseFloat(promotion.promoDiscountAmount ? promotion.promoDiscountAmount : '0');
                        if (promotion && amount > 0) {
                            var pc = promotion.promotionCycle;
                            return (React.createElement("div", { key: keyId },
                                React.createElement("div", { className: [styles.lineItemContainer, styles.linePromoSpace].join(' ') },
                                    React.createElement("div", { className: styles.lineItemName },
                                        React.createElement("div", { className: styles.lineItemPromo },
                                            React.createElement(ui_components_1.RichText, { testId: utils_1.default('ACCESSORY', 'Label', 'LineItem'), data: { isDecodingRequired: false,
                                                    text: promotion.promotionName } }))),
                                    React.createElement("div", { className: styles.lineItemPrice },
                                        React.createElement("div", { className: styles.promoPrice },
                                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('ACCESSORY', 'PriceContainer', 'LineItem'), data: {
                                                    billingNote: (pc === 'MONTHLY') ? '/mo.' : '', price: amount,
                                                }, options: {
                                                    decimalPoints: 2, isDataPriceNegative: true,
                                                    type: PriceContainerProps_1.PricingType.TILE,
                                                } }))))));
                        }
                        else {
                            return (React.createElement(React.Fragment, null, " "));
                        }
                    }
                }
                else {
                    return (React.createElement(React.Fragment, null, " "));
                }
            });
            return promotions;
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    AccessoriesCart.prototype.getSalesTax = function () {
        var isTaxCalculated = !!(this.payload && this.payload.orderPriceInfo &&
            this.payload.orderPriceInfo.taxCalculated);
        var toolTipText = this.isWirelessAccCart ? this.cmsContent.taxTooltipUpWireless :
            isTaxCalculated ? this.cmsContent.taxTooltipUp : this.cmsContent.taxTooltipDown;
        var totalTaxAmount = this.payload && this.payload.accessoryCart && this.payload.accessoryCart.totalLobTax || 0;
        if (this.isCommonCart) {
            this.losgData.forEach(function (losg) {
                totalTaxAmount = CommonUtils.getBsseTax(losg, 'DUE_UPON_FFL');
            });
            toolTipText = this.cmsContent.taxTooltipUpBsse;
        }
        return (React.createElement(React.Fragment, null,
            (this.isCommonCart || this.isWirelessAccCart) &&
                React.createElement("div", { className: [styles.grayLine, styles.pb17].join(' ') },
                    React.createElement("div", { className: CartCommonStyle.grayDivider })),
            React.createElement("div", { className: styles.lineItemContainer },
                React.createElement("div", { className: styles.lineItemName },
                    React.createElement("div", { className: styles.lineItemTax },
                        React.createElement(ui_components_1.RichText, { testId: utils_1.default('Accessory', 'Label', 'EstimatedSalesTax'), data: { text: this.cmsContent.estimatedSalesTax } }),
                        React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: { __html: toolTipText } }), testId: utils_1.default('Tooltip', 'Accessory_EstimatedSalesTax'), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                            React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION }))),
                    !isTaxCalculated && this.isCommonCart &&
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { testId: utils_1.default('DTVN', 'Label', 'TaxCalculated'), data: { text: this.cmsContent.taxNotCalculatedSubText || '(Calculated at checkout)' }, options: { className: styles.taxCalculatedSubtext } }))),
                React.createElement("div", { className: styles.lineItemPrice },
                    !isTaxCalculated &&
                        React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { testId: utils_1.default('Accessory', 'Lable', 'EmptyTaxText'), data: { text: '$--.--' }, options: { className: styles.salesTaxPrice } })),
                    isTaxCalculated &&
                        React.createElement("div", { className: CartCommonStyle.lineItemPrice },
                            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Accessory', 'PriceContainer', 'EstimatedSalesTax'), data: { billingNote: '', price: totalTaxAmount }, options: { decimalPoints: 2, isDataPriceNegative: false, type: PriceContainerProps_1.PricingType.TILE } })))),
            (this.isCommonCart || this.isWirelessAccCart) && this.showEditZipCode()));
    };
    AccessoriesCart.prototype.getShippingData = function () {
        if (this.props.data.shippingFee) {
            return (React.createElement("div", { className: styles.lineItemContainer },
                React.createElement("div", { className: styles.lineItemName },
                    React.createElement("div", { className: styles.lineItemTax },
                        React.createElement(ui_components_1.RichText, { testId: utils_1.default('Accessory', 'Label', 'ShippingLabel'), data: { text: this.cmsContent.shippingLabel } }))),
                React.createElement("div", { className: styles.lineItemPrice },
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Accessory', 'PriceContainer', 'ShippingLabel'), data: {
                            billingNote: '',
                            price: this.props.data.shippingFee,
                        }, options: {
                            decimalPoints: 2, isDataPriceNegative: false,
                            type: PriceContainerProps_1.PricingType.TILE,
                        } }))));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    AccessoriesCart.prototype.toggleRemoveModal = function (onlyPageLoadOnRemove) {
        var _this = this;
        this.setState({ isRemoveModalOpen: !this.state.isRemoveModalOpen }, function () {
            if (onlyPageLoadOnRemove) {
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                _this.onCartRemove();
            }
            else if (_this.state.isRemoveModalOpen) {
                _this.reportingService.fireLinkClickWithOutPageLoad(_this.cmsContent.removeItemsLinkLabel, ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
            }
            else {
                _this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
        });
    };
    AccessoriesCart.prototype.onCartRemove = function () {
        var _this = this;
        this.props.events.doLoading(true);
        this.reportingService.reportSystemEventForSelectedAction(false, '-2', this.cmsContent.removeItemsLinkLabel, ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
        var lobToRemove = this.isCommonCart ? 'WIRELESS' : 'ACCESSORY';
        this.api.emptyAnyLOBCart(lobToRemove).then(function (data) {
            if (data.content.status === 'success' || (_this.isCommonCart && data.content)) {
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.reportingService.reportSystemEventForSelectedAction(false, '0', _this.cmsContent.removeItemsLinkLabel, ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
                _this.setState({ showAccessoriesCart: false });
            }
            else {
                _this.reportingService.reportSystemEventForSelectedAction(true, undefined, _this.cmsContent.removeItemsLinkLabel, ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, "Error in remvoing cart: " + JSON.stringify(data));
            }
            _this.props.events.doLoading(false);
        }).catch(function (err) {
            _this.props.events.doLoading(false);
            _this.toggleRemoveModal();
        });
    };
    AccessoriesCart.prototype.getLineItemPrice = function (lineItem) {
        var amount = lineItem && lineItem.price && this.getPrice(lineItem.price) ?
            this.getPrice(lineItem.price) : 0;
        var subTotal = lineItem && lineItem.price && lineItem.price.amount || 0;
        if (this.isCommonCart || this.isWirelessAccCart) {
            var eachDevicePrice = lineItem.priceList && lineItem.priceList[0].baseAmount || 0;
            return (React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('ACCESSORY', 'PriceContainer', 'LineItem'), data: { billingNote: '/ea.', price: this.isWirelessAccCart ? subTotal :
                        eachDevicePrice }, options: { decimalPoints: 2, type: PriceContainerProps_1.PricingType.TILE } }));
        }
        else {
            return (React.createElement("div", { className: styles.lineItemPrice }, lineItem.price &&
                React.createElement("div", null,
                    lineItem._combinedProgrammingPromoPrice < 0 &&
                        React.createElement("span", null, "-"),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('ACCESSORY', 'PriceContainer', 'LineItem'), data: {
                            billingNote: '',
                            price: amount,
                        }, options: { decimalPoints: 2, type: PriceContainerProps_1.PricingType.TILE } }))));
        }
    };
    AccessoriesCart.prototype.editLineItem = function (editUrl) {
        this.props.events.onEdit('ACCESSORY', editUrl, 'Edit Line');
    };
    AccessoriesCart.prototype.removeLineItem = function (remove) {
        var _this = this;
        if (this.totalLosgItems === 1 && !this.isWirelessAccCart) {
            this.onCartRemove();
        }
        else {
            this.reportingService.fireLinkClickWithOutPageLoad('Remove line', ReportingService_1.PageUrls.CART_PAGE);
            var removeCartData = CommonUtils.buildRemoveAccessoryCartData(remove.losgInfo, remove.lineItem, this.payload);
            this.props.events.doLoading(true);
            this.api.addToCart(removeCartData).then(function (data) {
                _this.props.events.doLoading(false);
                if (data && data.content && data.content.payload) {
                    var isAccessory = !!(data.content.payload.commonCart &&
                        data.content.payload.commonCart.losgs) || !!_this.isWirelessAccCart;
                    _this.reportingService.reportSystemEventForSelectedAction(false, '0', _this.cmsContent.removeItemsLinkLabel, isAccessory ?
                        ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT : ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
                }
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }).catch(function (error) {
                _this.props.events.doLoading(false);
                _this.reportingService.reportSystemEventForSelectedAction(true, undefined, _this.cmsContent.removeItemsLinkLabel, ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, "Error in remvoing cart: " + JSON.stringify(error));
            });
        }
    };
    AccessoriesCart.prototype.getLineItemContent = function (lineItem, losg) {
        var _this = this;
        var wlsCMS = wlsUtils.getWlsCmsData();
        if (this.isWirelessAccCart) {
            if (lineItem.itemType.toUpperCase() === 'ACCESSORY') {
                var itemType = 'ACCESSORY';
                var removeInfo_1 = {
                    lineItem: lineItem,
                    losgInfo: losg,
                    losgsCount: this.losgData.length,
                    showEditAndRemove: (itemType === 'ACCESSORY') ? true : false,
                };
                var imgInfo = wlsUtils.getItemImage(lineItem);
                var itemEditUrl = this.getEditUrl(lineItem);
                this.itemImage.push(React.createElement("div", null, CommonHelper.getImageView(imgInfo)));
                this.itemDetails.push(React.createElement("div", null,
                    React.createElement(LineItem_1.default, { data: { altText: imgInfo && imgInfo.imgAltText || '',
                            deviceDetails: this.buildItemInfo(lineItem),
                            headingText: '',
                            imageUrl: imgInfo && imgInfo.imageUrl || '',
                            itemName: (itemType === 'ACCESSORY') ? lineItem.displayName : '', itemPriceInfo: (React.createElement(React.Fragment, null, " ")), showImage: false,
                            showLineItem: true }, events: { onItemEdit: this.editLineItem, onItemRemove: function () { _this.removeLineItem(removeInfo_1); } }, options: { editUrl: itemEditUrl, removeInfo: removeInfo_1, itemType: itemType } }),
                    React.createElement("div", null,
                        this.showQuantity(lineItem, losg),
                        this.isWirelessAccCart &&
                            lineItem.promotionReferences && lineItem.promotionReferences.length > 0
                            && this.showToolTipText(lineItem),
                        wirelessRTI.displayEstDeliveryDate(lineItem, wlsCMS.expupEstDateLabel) &&
                            React.createElement("div", { className: styles.estimatedDate }, this.isWirelessAccCart &&
                                wlsCMS && wlsCMS.expupEstDateLabel &&
                                wirelessRTI.displayEstDeliveryDate(lineItem, wlsCMS.expupEstDateLabel)),
                        wirelessRTI.displayAvailabilityMessage(lineItem, this.payload),
                        this.isWirelessAccCart && wlsUtils.isCommonDeliveryMethodAvailable(this.payload) &&
                            wirelessRTI.displayInventoryNotification(lineItem))));
                this.itemOtherInfo.push(!this.isWirelessAccCart &&
                    React.createElement(React.Fragment, null, this.getPromotion(lineItem)));
            }
        }
        else {
            // BAU VIEW
            this.itemDetails.push(React.createElement(React.Fragment, null,
                React.createElement("div", { className: [styles.lineItemContainer, styles.lineItemSpace].join(' ') },
                    React.createElement("div", { className: styles.lineItemName },
                        React.createElement("div", null,
                            React.createElement(ui_components_1.RichText, { testId: utils_1.default('ACCESSORY', 'Label', 'LineItem'), data: { text: this.getLineItemName(lineItem) } }),
                            this.shouldDisplayQuantity(lineItem) &&
                                React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: styles.quantity }),
                                    React.createElement("span", { className: styles.quantityText }, this.cmsContent.quantity + " " + this.getLineItemQuantity(lineItem))))),
                    this.getLineItemPrice(lineItem)),
                this.getPromotion(lineItem)));
        }
    };
    AccessoriesCart.prototype.buildItemInfo = function (lineItem) {
        return (React.createElement(ui_components_1.RichText, { testId: utils_1.default('ACCESSORY', 'Label', 'LineItem'), data: { text: this.getLineItemName(lineItem) } }));
    };
    AccessoriesCart.prototype.changeAccessoryQuantity = function (key, losg, lineItem) {
        var _this = this;
        var postRequest = CommonUtils.updateAccessoryQuantity(key, losg, lineItem, this.payload);
        this.reportingService.fireCartUpdateSubmitEvent(false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, key > 0 ? 'Update' : 'Delete', undefined, CartUtils.getLinkClickBasekUrl());
        this.props.events.doLoading(true);
        this.api.addToCart(postRequest).then(function (data) {
            _this.props.events.doLoading(false);
            if (data && data.content &&
                (data.content.payload || (data.content.payload === undefined && _this.totalLosgItems === 1))) {
                _this.reportingService.fireCartUpdateSubmitEvent(false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, key > 0 ? 'Update' : 'Delete', undefined, CartUtils.getLinkClickBasekUrl());
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
            }
            else {
                _this.reportingService.fireCartUpdateSubmitEvent(true, undefined, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, key > 0 ? 'Update' : 'Delete', JSON.stringify(data), CartUtils.getLinkClickBasekUrl());
            }
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
        }).catch(function (error) {
            _this.props.events.doLoading(false);
            _this.reportingService.fireCartUpdateSubmitEvent(false, error && error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, key > 0 ? 'Update' : 'Delete', JSON.stringify(error), CartUtils.getLinkClickBasekUrl());
        });
    };
    AccessoriesCart.prototype.showQuantity = function (lineItem, losg) {
        var _this = this;
        var _a, _b;
        var total = 0;
        var modaldataList = [];
        if (lineItem && lineItem.maxSkusPerOrder) {
            for (var i = 1; i <= lineItem.maxSkusPerOrder; i++) {
                modaldataList.push(i.toString());
            }
        }
        var modalData = this.isWirelessAccCart && modaldataList
            ? modaldataList : this.isWirelessAccCart ? ['1', '2', '3', '4'] :
            ['1', '2', '3', '4', 'Delete'];
        if (this.isCommonCart) {
            total = (lineItem.priceList && lineItem.priceList[0].totalbeforeTax) ?
                lineItem.priceList[0].totalbeforeTax : lineItem.priceList[0].baseAmount;
        }
        else if (this.isWirelessAccCart) {
            total = ((_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) === null || _a === void 0 ? void 0 : _a.subTotal) || 0;
        }
        else {
            total = ((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.price) === null || _b === void 0 ? void 0 : _b.total) || 0;
        }
        var itemDetails = (React.createElement("div", { className: [styles.accQtyContainer, styles.quantityContainer].join(' ') },
            React.createElement("div", { className: styles.displayContent },
                React.createElement("span", null, "("),
                React.createElement("div", { className: styles.accItemPrice }, this.getLineItemPrice(lineItem)),
                React.createElement("span", null, ")")),
            React.createElement("div", { className: styles.accQty },
                React.createElement(PostpaidAccessoryModal_1.default, { data: {
                        disableDelete: this.isWirelessAccCart ? true : false,
                        elementId: lineItem.id + '_Accessory',
                        linkText: "Qty: " + lineItem.quantity,
                        modalData: modalData,
                        selected: lineItem.quantity,
                    }, events: {
                        selectionChange: function (e) { return _this.changeAccessoryQuantity(e, losg, lineItem); },
                    } }))));
        var itemPrice = (React.createElement("div", { className: styles.lineItemPrice },
            React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('ACCESSORY', 'PriceContainer', 'LineItem'), data: { billingNote: '', price: total }, options: { decimalPoints: 2, type: PriceContainerProps_1.PricingType.TILE } })));
        return (React.createElement(React.Fragment, null,
            React.createElement(LineItem_1.default, { data: { deviceDetails: itemDetails,
                    itemPriceInfo: itemPrice,
                    showImage: false,
                    showLineItem: true }, events: {}, options: {} })));
    };
    AccessoriesCart.prototype.showEditZipCode = function () {
        var _a, _b;
        var taxZipCode = '';
        this.losgData.forEach(function (losg) {
            var _a;
            taxZipCode = (_a = losg === null || losg === void 0 ? void 0 : losg.losgTaxInfo) === null || _a === void 0 ? void 0 : _a.taxZipCode;
        });
        if (this.isWirelessAccCart) {
            taxZipCode = ((_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.taxZipCode) || '';
        }
        var enableEdit = Utils.IsAccessoryOnlyInCart() ? false : true;
        if (taxZipCode) {
            return (React.createElement("div", { className: styles.m10Top },
                React.createElement(CartZipEdit_1.default, { data: {
                        displayTaxZip: !!taxZipCode,
                        isEditable: enableEdit,
                        zipCode: taxZipCode,
                        zipDisplayContent: 'Tax based on ZIP Code ',
                        zipErrorContent: 'ZIP Code is invalid',
                        zipUpdateButtonContent: 'Update',
                    } })));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AccessoriesCart.prototype.getEditUrl = function (lineItem) {
        var url = lineItem.pscEditUrl || this.editUrl;
        return url;
    };
    AccessoriesCart.prototype.showToolTipText = function (lineItem) {
        return (React.createElement(React.Fragment, null,
            React.createElement(TextTooltip_1.default, { data: { linkText: 'See discounts' }, events: { doLoading: this.props.events.doLoading }, options: {} }, this.showAccPromoText(lineItem))));
    };
    AccessoriesCart.prototype.savingText = function () {
        var _a, _b, _c;
        var savingLabel;
        var totalOneTimeSavings = ((_c = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.savingsInfo) === null || _c === void 0 ? void 0 : _c.totalOneTimeSavings) || 0;
        this.savingsAndPromosCms = wlsUtils.getSavingsAndPromosCmsData();
        if (this.isWirelessAccCart && this.savingsAndPromosCms && totalOneTimeSavings &&
            this.savingsAndPromosCms.oneTimeSavingsLabel) {
            savingLabel = this.savingsAndPromosCms.oneTimeSavingsLabel.replace('{0}', Utils.amountWithDecimal(totalOneTimeSavings, 2, '$'));
        }
        return savingLabel || '';
    };
    AccessoriesCart.prototype.showAccPromoText = function (lineItem) {
        if (lineItem) {
            var totalQty = this.getLineItemQuantity(lineItem);
            var amount = lineItem && lineItem.price && this.getPrice(lineItem.price) ?
                this.getPrice(lineItem.price) : 0;
            var retailPriceLabel = this.cmsContent && this.cmsContent.retailPriceLabel && amount && totalQty
                && this.cmsContent.retailPriceLabel.replace(' {0}', String(amount))
                    .replace('{1}', String(totalQty)) || '';
            var retailPriceText = retailPriceLabel && (React.createElement("span", { className: styles.quantityText },
                React.createElement("div", { className: [styles.accQtyContainer, styles.quantityContainer].join(' ') },
                    React.createElement("div", { className: styles.displayContent }, retailPriceLabel))));
            var subTotal = (lineItem.price && lineItem.price.subTotal) ?
                lineItem.price.subTotal : 0;
            return (retailPriceText && lineItem.price && lineItem.price.total && subTotal && (React.createElement("div", null,
                React.createElement("div", { className: textTooptipStyles.lineHeading },
                    " ",
                    this.getLineItemName(lineItem),
                    " "),
                React.createElement("div", { className: textTooptipStyles.planItem },
                    React.createElement("span", null, retailPriceText),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'Plan', 'Price'), data: { price: lineItem.price.total }, options: {
                            className: textTooptipStyles.lineItemPrice,
                            decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL,
                        } })),
                this.getPromotion(lineItem),
                React.createElement("div", { className: textTooptipStyles.solidLine }),
                React.createElement("div", { className: textTooptipStyles.planItem },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: 'Subtotal' }, options: { className: textTooptipStyles.planMonthlyCharge } })),
                    React.createElement("div", null,
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'Accessory', 'Subtotal'), data: { price: subTotal }, options: {
                                className: textTooptipStyles.lineItemPrice,
                                decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL,
                            } }))),
                React.createElement("div", null,
                    React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: 'Excludes sales tax' }, options: { className: textTooptipStyles.planFotterMessage } })))) || React.createElement(React.Fragment, null));
        }
        return React.createElement(React.Fragment, null);
    };
    return AccessoriesCart;
}(React.Component));
exports.default = AccessoriesCart;
//# sourceMappingURL=AccessoriesCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/AccessoriesCart/AccessoriesCart.js
// module id = 2322
// module chunks = 8